import { Users } from '../models/UserCollection';
import { ChatMessageNotification } from '../models/ChatMessage';
import { ChatActions } from './ChatActions';

export default class RpgMessage {
	constructor(rpg) {
		this.attacker = null;
		this.defender = null;
		this.message = null;
		this.attack = null;
		this.rpg = rpg;
		console.log('the rpg message', rpg);
		if(rpg.attack) {
			this.attack = rpg.attack;
		}

		if(rpg.message) {
			this.setMessage(rpg.message);
		}
		console.log('what is rpg', rpg);
		if(rpg.defender) {
			this.defender = Users.update(rpg.defender);
		}
		if(rpg.defending) {
			if(rpg.defending.message) {
				this.setMessage(rpg.defending.message);
			}

		}
		if(rpg.attack && rpg.attack.message) {
			let attack = rpg.attack;
			if(attack.attacker) {
				this.attacker = Users.retrieveById(attack.attacker.player.id);
				this.attacker.hitPoints.setHealth(attack.attacker.hit_points);
			}
			if(attack.defender) {
				this.defender = Users.retrieveById(attack.defender.player.id);
				this.defender.hitPoints.setHealth(attack.defender.hit_points);
			}

			let message = attack.message;
			if(message) {
				this.setMessage(message);
			}
			if(attack.death) {
				if(attack.death.message) {
					this.setMessage(attack.death.message);
				}
			}
		}

	}

	createNotification() {
		const notificationMessage = ChatMessageNotification.create();
		notificationMessage.type = ChatMessageNotification.types.RPG_MESSAGE;
		notificationMessage.message = this.message;
		notificationMessage.rpg = this;
		ChatActions.addNotificationToChat(null, notificationMessage);
		return notificationMessage;
	}

	setMessage(message) {
		this.message = message;
	}
}